import React from 'react';
import { Box } from '@material-ui/core';

import HeroSliderItem from './HeroSliderItem/HeroSliderItem';
import Carousel from '../../ui/Carousel/Carousel';
import { HeroSlide } from 'domain/types';

interface HeroSliderProps {
  heroSlides: Array<HeroSlide>;
}

const HeroSlider: React.FC<HeroSliderProps> = ({ heroSlides }): JSX.Element => {
  return (
    <Box mb={6}>
      <Carousel
        settings={{
          slidesToScroll: 1,
          slidesToShow: 1,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 5000,
          dots: true
        }}
      >
        {heroSlides.map((item, index) => (
          <HeroSliderItem item={item} priority={index === 0} key={item.sys.id} />
        ))}
      </Carousel>
    </Box>
  );
};

export default HeroSlider;
